// src/components/MfaSetupGate.js
//
// Sends a signed-in system admin with no authenticator app to set-up, from
// whatever page they are on. ProtectedRoute does the same for the pages it
// wraps, but the landing route and the workspace picker are not wrapped: on
// 2026-10-05 a system admin whose browser was already signed in landed on the
// picker, chose a workspace, and got "Failed to set up subscriber access" with
// nothing saying an authenticator was needed. Rendered once, inside the
// router, so no route can be missed.
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function MfaSetupGate() {
  const { currentUser, mfaSetupRequired } = useAuth();
  const location = useLocation();

  if (currentUser && mfaSetupRequired && location.pathname !== '/enroll-mfa') {
    return <Navigate to="/enroll-mfa" replace />;
  }
  return null;
}
